import React from 'react';
import { Card, Typography } from 'antd';
import '../styles/Guide.css';

const { Title, Paragraph } = Typography;

/**
 * Generic layout for "How to request your data" guides.
 *
 * props:
 * - title: string
 * - intro?: string
 * - steps: Array<{
 *     id?: string;
 *     stepLabel?: string;       // e.g. "Step 1" (auto-falls back to index+1)
 *     title?: string;
 *     body?: React.ReactNode;
 *     image?: string;           // import path
 *     imageAlt?: string;
 *     badge?: string;           // optional small pill (e.g. "Mobile app")
 *   }>
 */
const DataRequestGuide = ({ title, intro, steps }) => {
  return (
    <div className="Guide-root">
      <Title level={2} className="Guide-title">
        {title}
      </Title>

      {intro && (
        <Paragraph className="Guide-intro">
          {intro}
        </Paragraph>
      )}

      <div className="Guide-steps">
        {steps.map((step, index) => (
          <Card
            key={step.id || index}
            className="Guide-stepCard"
            bordered={false}
          >
            <div className="Guide-stepHeader">
              <span className="Guide-stepLabel">
                {step.stepLabel || `Step ${index + 1}`}
              </span>
              {step.badge && (
                <span className="Guide-stepBadge">
                  {step.badge}
                </span>
              )}
            </div>

            {step.image && (
              <div className="Guide-stepImageWrapper">
                <img
                  src={step.image}
                  alt={step.imageAlt || step.title || step.stepLabel}
                  className="Guide-stepImage"
                />
              </div>
            )}

            <div className="Guide-stepText">
              {step.title && (
                <Title level={4} className="Guide-stepTitle">
                  {step.title}
                </Title>
              )}
              {step.body && (
                <Paragraph className="Guide-stepBody">
                  {step.body}
                </Paragraph>
              )}
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default DataRequestGuide;
